import { SxProps, Theme } from '@mui/material';

export const productPLPDiscountSX: SxProps<Theme> = () => ({
	color: '#AB2326',
	fontSize: 'var(--font-size-sm)',
	fontWeight: '600',
	marginRight: '8px',
	textDecoration: 'none',
});

export const productPLPPriceSX: SxProps<Theme> = {
	color: '#2C2C2C',
	fontSize: 'var(--font-size-sm)',
	fontWeight: '600',
};

export const productPLPTitleSX: SxProps<Theme> = () => ({
	color: '#2C2C2C',
	fontSize: { xs: 'var(--font-size-default)', sm: 'var(--font-size-body)' },
	fontWeight: '600',
	textDecoration: 'none',
	overflow: 'hidden',
	display: '-webkit-box',
	WebkitLineClamp: 3,
	WebkitBoxOrient: 'vertical',
	textOverflow: 'ellipsis',
	mb: '4px',
});

export const productPLPSubtitleSX: SxProps<Theme> = () => ({
	color: '#2C2C2C',
	fontSize: 'var(--font-size-default)',
	fontWeight: '500',
	textDecoration: 'none',
	textTransform: 'capitalize',
});
